import React, { useState, useEffect, useRef } from 'react';
import authAxios from "../../services/Token";
import { apiImage } from "../../services/Api";
import { 
    Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input,
    Table, Spinner, Badge, Card, CardHeader, CardBody, Row, Col,
    Alert
} from "reactstrap";

const AllDocuments = () => {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [viewerModal, setViewerModal] = useState({ open: false, document: null });
    const [detailModal, setDetailModal] = useState({ open: false, document: null });
    const [users, setUsers] = useState([]);
    const [folders, setFolders] = useState([]);
    const [areasEmpresa, setAreasEmpresa] = useState([]);
    const [tipoDocumento, setTipoDocumento] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [loadingFolders, setLoadingFolders] = useState(false);
    const [documento_nombre, setDocumentoNombre] = useState('');
    const [documento_codigo, setDocumentoCodigo] = useState('');
    const [documento_version, setDocumentoVersion] = useState('');
    const [documento_solicitante, setDocumentoSolicitante] = useState('');
    // Estados para crear nuevo documento
    const [createModal, setCreateModal] = useState({
        open: false,
        formData: {
            name: '',
            description: '',
            version: '',
            tipo_documento: '',
            area_solicitante: '',
            request_type: '',
            creation_date: '',
            folder_id: '',
            documento_id: null,
            pregunta_1: false,
            pregunta_2: false,
            pregunta_3: false,
            pregunta_4: false
        },
        file: null,
        uploading: false
    });

    // Estados para editar documento
    const [editModal, setEditModal] = useState({ 
        open: false, 
        document: null,
        formData: {
            name: '',
            description: '',
            version: '',
            tipo_documento: '',
            area_solicitante: '',
            request_type: '',
            creation_date: '',
            status: '',
            observacion_solicitud:'',
            folder_id: '',
            documento_id: null,
            user:'',
            pregunta_1: false,
            pregunta_2: false,
            pregunta_3: false,
            pregunta_4: false
        },
        file: null,
        uploading: false,
        replaceFile: false
    });
    
    // Estados para filtros - AÑADIDO approval_start_date y approval_end_date
    const [filters, setFilters] = useState({
        name: '',
        status: 'todos',
        request_type: 'todos',
        date: '',
        user_id: '',
        start_date: '',
        end_date: '',
        approval_start_date: '', // Nuevo filtro
        approval_end_date: '',   // Nuevo filtro
        tipo_documento: 'todos',
        area_solicitante: '',
        folder_id: 'todos'
    });
    
    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        per_page: 20,
        total: 0
    });
    
    // Estados para aprobar/rechazar
    const [statusModal, setStatusModal] = useState({ 
        open: false, 
        document: null, 
        action: '',
        acta_number: '',
        acta_version: '',
        acta_fecha_apro: '',
        observation: ''
    });
    
    // Nuevos estados para documentos aprobados
    const [documentosAprobados, setDocumentosAprobados] = useState([]);
    const [loadingDocumentosAprobados, setLoadingDocumentosAprobados] = useState(false);
    const [selectDocumentoModal, setSelectDocumentoModal] = useState({
        open: false,
        forCreate: false,
    });
    
    // Filtros para la tabla de documentos aprobados
    const [filtrosDocumentosAprobados, setFiltrosDocumentosAprobados] = useState({
        name: '',
        codigo: '',
        area_solicitante: '',
        tipo_documento: ''
    });

    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        loadDocuments();
        loadUsers();
        loadFolders();
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        loadDocuments();
        loadTipoDocumento();
    }, [filters, pagination.current_page]);

    const loadTipoDocumento = async () => {
        try {
            const response = await authAxios.get('tipodocumento/all');
            if (response.data && response.data.tipos) {
                setTipoDocumento(response.data.tipos);
            }
        } catch (error) {
            console.error('Error loading areas:', error);
        }
    };

    const loadDocuments = async () => {
        if (!isMounted.current) return;
        
        setLoading(true);
        try {
            const params = {
                ...filters,
                page: pagination.current_page
            };
            
            Object.keys(params).forEach(key => {
                if (params[key] === '' || params[key] === 'todos') {
                    delete params[key];
                }
            });
            
            const response = await authAxios.get('documents/all', { params });
            
            if (isMounted.current) {
                const responseData = response.data;
                
                if (responseData.data && Array.isArray(responseData.data)) {
                    setDocuments(responseData.data);
                    setPagination({
                        current_page: responseData.current_page || 1,
                        last_page: responseData.last_page || 1,
                        per_page: responseData.per_page || 20,
                        total: responseData.total || responseData.data.length
                    });
                    
                    if (responseData.areas_empresa && Array.isArray(responseData.areas_empresa)) {
                        setAreasEmpresa(responseData.areas_empresa);
                    }
                } else if (Array.isArray(responseData)) {
                    setDocuments(responseData);
                    setPagination({
                        current_page: 1,
                        last_page: 1,
                        per_page: responseData.length,
                        total: responseData.length
                    });
                } else {
                    setDocuments([]);
                    console.warn('Formato de respuesta inesperado:', responseData);
                }
            }
        } catch (error) {
            console.error('Error loading documents:', error);
            if (isMounted.current) {
                alert('Error al cargar los documentos: ' + (error.response?.data?.message || error.message));
            }
        } finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    };

    // Función para cargar documentos aprobados
    const loadDocumentosAprobados = async () => {
        try {
            setLoadingDocumentosAprobados(true);
            
            // Crear objeto de parámetros de filtro
            const params = {};
            
            // Solo agregar filtros que tengan valor
            if (filtrosDocumentosAprobados.name) {
                params.name = filtrosDocumentosAprobados.name;
            }
            if (filtrosDocumentosAprobados.codigo) {
                params.codigo = filtrosDocumentosAprobados.codigo;
            }
            if (filtrosDocumentosAprobados.area_solicitante) {
                params.area_solicitante = filtrosDocumentosAprobados.area_solicitante;
            }
            if (filtrosDocumentosAprobados.tipo_documento) {
                params.tipo_documento = filtrosDocumentosAprobados.tipo_documento;
            }
            
            const response = await authAxios.get('documents/aprobados', { params });
            if (response.data) {
                setDocumentosAprobados(response.data);
            }
        } catch (error) {
            console.error('Error loading approved documents:', error);
            alert('Error al cargar documentos aprobados');
        } finally {
            setLoadingDocumentosAprobados(false);
        }
    };

    // Abrir modal de creación
    const openCreateModal = () => {
        setCreateModal({
            open: true,
            formData: {
                name: '',
                description: '',
                observacion_solicitud: '',
                version: '1.0',
                tipo_documento: '',
                area_solicitante: '',
                request_type: 'creacion',
                creation_date: new Date().toISOString().split('T')[0],
                folder_id: '',
                documento_id: null,
                pregunta_1: false,
                pregunta_2: false,
                pregunta_3: false,
                pregunta_4: false
            },
            file: null,
            uploading: false
        });
    };

    // Manejar cambios en el formulario de creación
    const handleCreateChange = (field, value) => {
        const newFormData = {
            ...createModal.formData,
            [field]: value
        };

        // Si el request_type cambia a "actualizacion", carga los documentos aprobados
        if (field === 'request_type' && value === 'actualizacion') {
            loadDocumentosAprobados();
            setSelectDocumentoModal({
                open: true,
                forCreate: true
            });
        }

        setCreateModal(prev => ({
            ...prev,
            formData: newFormData
        }));
    };

    // Manejar selección de archivo en creación
    const handleCreateFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCreateModal(prev => ({
                ...prev,
                file: file
            }));
        }
    };

    // Función para seleccionar documento
    const selectDocumento = (documento) => {
        if (selectDocumentoModal.forCreate) {
            // Para creación
            handleCreateChange('documento_id', documento.id);
            setDocumentoNombre(documento.name);
            setDocumentoCodigo(documento.codigo);
            setDocumentoVersion(documento.version);
            setDocumentoSolicitante(documento.user?.nombre || '');
        } else {
            // Para edición
            handleEditChange('documento_id', documento.id);
            setDocumentoNombre(documento.name);
            setDocumentoCodigo(documento.codigo);
            setDocumentoVersion(documento.version);
            setDocumentoSolicitante(documento.user?.nombre || '');
        }
        setSelectDocumentoModal({ open: false, forCreate: false });
    };

    // Crear nuevo documento
    const createDocument = async () => {
        try {
            const { formData, file } = createModal;
            
            // Validaciones
            if (!file) {
                alert('Por favor selecciona un archivo');
                return;
            }

            if (!formData.folder_id) {
                alert('Por favor selecciona una carpeta');
                return;
            }

            // Validar que si es actualización, debe tener documento_id
            if (formData.request_type === 'actualizacion' && !formData.documento_id) {
                alert('Para una actualización, debes seleccionar un documento a actualizar');
                return;
            }

            // Preparar datos
            const submitData = new FormData();
            Object.keys(formData).forEach(key => {
                if (key === 'pregunta_1' || key === 'pregunta_2' || key === 'pregunta_3' || key === 'pregunta_4') {
                    submitData.append(key, formData[key] ? 1 : 0);
                } else if (formData[key] !== null) {
                    submitData.append(key, formData[key]);
                }
            });
            submitData.append('file', file);

            setCreateModal(prev => ({ ...prev, uploading: true }));

            const response = await authAxios.post('documents', submitData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data) {
                alert('Documento creado exitosamente');
                setCreateModal({ 
                    open: false, 
                    formData: {
                        name: '',
                        description: '',
                        observacion_solicitud: '',
                        version: '',
                        tipo_documento: '',
                        area_solicitante: '',
                        request_type: '',
                        creation_date: '',
                        folder_id: '',
                        documento_id: null,
                        pregunta_1: false,
                        pregunta_2: false,
                        pregunta_3: false,
                        pregunta_4: false
                    },
                    file: null,
                    uploading: false
                });
                loadDocuments();
            }
        } catch (error) {
            console.error('Error creating document:', error);
            alert('Error al crear el documento: ' + (error.response?.data?.message || error.message));
        } finally {
            setCreateModal(prev => ({ ...prev, uploading: false }));
        }
    };

    // Abrir modal de edición
    const openEditModal = async (document) => {
        console.log(document);
        try {
            setEditModal({
                open: true,
                document,
                formData: {
                    name: document.name || '',
                    description: document.description || '',
                    observacion_solicitud: document.observacion_solicitud || '',
                    status: document.status || '',
                    documento_id: document.id || '',
                    version: document.version || '',
                    tipo_documento: document.tipo_documento || '',
                    area_solicitante: document.area_solicitante || '',
                    user: document.user.nombre || '',
                    request_type: document.request_type || '',
                    creation_date: document.creation_date ? document.creation_date.split('T')[0] : '',
                    folder_id: document.folder_id || '',
                    pregunta_1: document.pregunta_1 === 1,
                    pregunta_2: document.pregunta_2 === 1,
                    pregunta_3: document.pregunta_3 === 1,
                    pregunta_4: document.pregunta_4 === 1
                },
                file: null,
                uploading: false,
                replaceFile: false
            });
            
            // Si el documento tiene un documento padre, cargar sus datos
            if (document.documento_id) {
                try {
                    const response = await authAxios.get(`verdocumento/${document.documento_id}`);
                    const documentData = response.data;
                    setDocumentoNombre(documentData.name);
                    setDocumentoCodigo(documentData.codigo);
                    setDocumentoVersion(documentData.version);
                    setDocumentoSolicitante(documentData.user?.nombre || '');
                } catch (error) {
                    console.error('Error loading document details:', error);
                }
            } else {
                // Limpiar los datos si no hay documento padre
                setDocumentoNombre('');
                setDocumentoCodigo('');
                setDocumentoVersion('');
                setDocumentoSolicitante('');
            }
        } catch (error) {
            console.error('Error loading document details:', error);
            alert('Error al cargar detalles del documento');
        }
    };

    // Manejar cambios en el formulario de edición
    const handleEditChange = (field, value) => {
        const newFormData = {
            ...editModal.formData,
            [field]: value
        };

        // Si el request_type cambia a "actualizacion", carga los documentos aprobados
        if (field === 'request_type' && value === 'actualizacion' && editModal.formData.documento_id === null) {
            loadDocumentosAprobados();
            setSelectDocumentoModal({
                open: true,
                forCreate: false
            });
        }

        setEditModal(prev => ({
            ...prev,
            formData: newFormData
        }));
    };

    // Manejar selección de archivo en edición
    const handleEditFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setEditModal(prev => ({
                ...prev,
                file: file,
                replaceFile: true
            }));
        }
    };

    // Actualizar documento
    const updateDocument = async () => {
        try {
            const { document, formData, file, replaceFile } = editModal;
            
            // Validar que si es actualización, debe tener documento_id
            if (formData.request_type === 'actualizacion' && !formData.documento_id) {
                alert('Para una actualización, debes seleccionar un documento a actualizar');
                return;
            }

            // Preparar datos
            const submitData = new FormData();
            Object.keys(formData).forEach(key => {
                if (key === 'pregunta_1' || key === 'pregunta_2' || key === 'pregunta_3' || key === 'pregunta_4') {
                    submitData.append(key, formData[key] ? 1 : 0);
                } else if (formData[key] !== null) {
                    submitData.append(key, formData[key]);
                }
            });

            // Si se seleccionó un nuevo archivo, agregarlo
            if (replaceFile && file) {
                submitData.append('file', file);
            }

            setEditModal(prev => ({ ...prev, uploading: true }));

            const response = await authAxios.post(`documents/${document.id}?_method=PUT`, submitData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data) {
                alert('Documento actualizado exitosamente');
                setEditModal({ 
                    open: false, 
                    document: null,
                    formData: {
                        name: '',
                        description: '',
                        observacion_solicitud: '',
                        version: '',
                        tipo_documento: '',
                        area_solicitante: '',
                        request_type: '',
                        creation_date: '',
                        folder_id: '',
                        documento_id: null,
                        pregunta_1: false,
                        pregunta_2: false,
                        pregunta_3: false,
                        pregunta_4: false
                    },
                    file: null,
                    uploading: false,
                    replaceFile: false
                });
                loadDocuments();
            }
        } catch (error) {
            console.error('Error updating document:', error);
            alert('Error al actualizar el documento: ' + (error.response?.data?.message || error.message));
        } finally {
            setEditModal(prev => ({ ...prev, uploading: false }));
        }
    };

    const loadUsers = async () => {
        if (!isMounted.current) return;
        
        setLoadingUsers(true);
        try {
            const response = await authAxios.get('chat/todos');
            
            if (response.data && response.data.success) {
                const usersData = response.data.data;
                
                if (Array.isArray(usersData)) {
                    if (isMounted.current) {
                        setUsers(usersData);
                    }
                } else {
                    console.warn('Formato de usuarios inesperado:', usersData);
                    if (isMounted.current) {
                        setUsers([]);
                    }
                }
            } else {
                console.warn('No se pudo cargar la lista de usuarios');
                if (isMounted.current) {
                    setUsers([]);
                }
            }
            
        } catch (error) {
            console.error('Error loading users:', error);
            if (isMounted.current) {
                setUsers([]);
            }
        } finally {
            if (isMounted.current) {
                setLoadingUsers(false);
            }
        }
    };

    const loadFolders = async () => {
        if (!isMounted.current) return;
        
        setLoadingFolders(true);
        try {
            const response = await authAxios.get('folders');
            
            if (isMounted.current) {
                if (Array.isArray(response.data)) {
                    setFolders(response.data);
                } else {
                    console.warn('Formato de carpetas inesperado:', response.data);
                    setFolders([]);
                }
            }
        } catch (error) {
            console.error('Error loading folders:', error);
            if (isMounted.current) {
                setFolders([]);
            }
        } finally {
            if (isMounted.current) {
                setLoadingFolders(false);
            }
        }
    };

    // Función para actualizar el estado del documento
    const updateDocumentStatus = async (documentId, status, acta_number = '', observation = '', acta_version = '', acta_fecha = '', codigo = '') => {
        try {
            await authAxios.put(`documents/${documentId}/status`, {
                status,
                acta_number: status === 'aprobado' ? acta_number : null,
                rejection_observation: observation,
                acta_version: status === 'aprobado' ? acta_version : null,
                acta_fecha: status === 'aprobado' ? acta_fecha : null,
                codigo: status === 'aprobado' ? codigo : null
            });
            
            loadDocuments();
            setStatusModal({ 
                open: false, 
                document: null, 
                action: '',
                acta_number: '',
                observation: '',
                acta_version: '',
                acta_fecha: '',
            });
            alert('Estado del documento actualizado correctamente');
        } catch (error) {
            console.error('Error updating document status:', error);
            alert('Error al actualizar el estado: ' + (error.response?.data?.message || error.message));
        }
    };

    // Función para eliminar documento
    const deleteDocument = async (documentId) => {
        if (!window.confirm('¿Estás seguro de que quieres eliminar este documento?')) {
            return;
        }
        
        try {
            await authAxios.delete(`documents/${documentId}`);
            loadDocuments();
            alert('Documento eliminado correctamente');
        } catch (error) {
            console.error('Error deleting document:', error);
            alert('Error al eliminar el documento: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
        setPagination(prev => ({ ...prev, current_page: 1 }));
    };

    const clearFilters = () => {
        setFilters({
            name: '',
            status: 'todos',
            request_type: 'todos',
            date: '',
            user_id: '',
            start_date: '',
            end_date: '',
            approval_start_date: '', // Añadido
            approval_end_date: '',   // Añadido
            tipo_documento: 'todos',
            area_solicitante: '',
            folder_id: 'todos'
        });
        setPagination(prev => ({ ...prev, current_page: 1 }));
    };

    // Función para manejar cambios en filtros de documentos aprobados
    const handleFiltrosDocumentosAprobadosChange = (key, value) => {
        setFiltrosDocumentosAprobados(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // Función para limpiar filtros de documentos aprobados
    const clearFiltrosDocumentosAprobados = () => {
        setFiltrosDocumentosAprobados({
            name: '',
            codigo: '',
            area_solicitante: '',
            tipo_documento: ''
        });
    };

    const getDocumentUrl = (document) => {
        if (!document.file_path) return null;
        return `${apiImage}${document.file_path}`;
    };

    const downloadDocument = async (doc) => {
        try {
            const fileUrl = getDocumentUrl(doc);
            console.log(fileUrl)
            if (!fileUrl) {
                alert('No se encontró la ruta del archivo');
                return;
            }

            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', doc.name || 'documento');
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
        } catch (error) {
            console.error('Error downloading document:', error);
            alert('Error al descargar el documento');
        }
    };

    const viewDocument = (document) => {
        const fileUrl = getDocumentUrl(document);
        if (fileUrl) {
            setViewerModal({ open: true, document: { ...document, file_url: fileUrl } });
        } else {
            alert('No se puede visualizar el documento: Ruta no disponible');
        }
    };

    const viewDocumentDetails = (document) => {
        setDetailModal({ open: true, document });
        verdocumentos(document.documento_id);
        
    };
    
    const verdocumentos =  async (id) => {
        if(id && id != 0){
            try {
                const response = await authAxios.get(`verdocumento/${id}`);
                const documentData = response.data;
                setDocumentoNombre(documentData.name);
                setDocumentoCodigo(documentData.codigo);
                setDocumentoVersion(documentData.version);
                setDocumentoSolicitante(documentData.user?.nombre || '');
            } catch (error) {
                console.error('Error loading related document:', error);
            }
        }
    }
    
    const getStatusBadge = (status) => {
        const statusConfig = {
            sin_revisar: { color: 'secondary', text: 'Sin Revisar' },
            en_proceso: { color: 'warning', text: 'En Proceso' },
            aprobado: { color: 'success', text: 'Aprobado' },
            rechazado: { color: 'danger', text: 'Rechazado' },
            reemplazado: { color: 'danger', text: 'Reemplazado' }
        };
        const config = statusConfig[status] || statusConfig.sin_revisar;
        return <Badge color={config.color}>{config.text}</Badge>;
    };

    const getFileIcon = (fileType) => {
        if (!fileType) return '📎';
        
        const type = fileType.toLowerCase();
        
        if (type.includes('pdf')) return '📕';
        if (type.includes('image')) return '🖼️';
        if (type.includes('xlsx') || type.includes('excel') || type.includes('spreadsheet')) return '📊';
        if (type.includes('word') || type.includes('document') || type.includes('doc')) return '📃';
        if (type.includes('text') || type.includes('txt')) return '📄';
        if (type.includes('powerpoint') || type.includes('presentation')) return '📑';
        if (type.includes('zip') || type.includes('rar') || type.includes('compressed')) return '🗜️';
        if (type.includes('video')) return '🎬';
        if (type.includes('audio')) return '🎵';
        if (type.includes('csv')) return '📈';
        return '📎';
    };

    const formatFileSize = (bytes) => {
        if (!bytes) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const getFolderPath = (document) => {
        if (!document.folder) return 'N/A';
        
        const getFullPath = (folder) => {
            if (folder.parent) {
                return getFullPath(folder.parent) + ' / ' + folder.name;
            }
            return folder.name;
        };
        
        return getFullPath(document.folder);
    };

    const getUserName = (user) => {
        if (!user) return 'N/A';
        return user.nombre || user.name || user.email || `Usuario ${user.id}`;
    };

    // Funciones para el modal de detalles
    const getPreguntaText = (preguntaNum) => {
        const preguntas = {
            1: "Se crea o da de baja un documento del sistema de calidad",
            2: "Se crea, da de baja o se cambia el título a un formato del sistema de calidad",
            3: "Se cambian, incluyen o excluyen los títulos de los cargos en el organigrama y demás documentos del sistema de calidad",
            4: "La creación, actualización o dada de baja afecta la documentación del sistema de calidad"
        };
        return preguntas[preguntaNum] || '';
    };

    const getPreguntaBadge = (value) => {
        return value ? 
            <Badge color="success">Sí</Badge> : 
            <Badge color="secondary">No</Badge>;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'No especificada';
        
        try {
            const datePart = dateString.split('T')[0];
            const [year, month, day] = datePart.split('-');
            const date = new Date(year, month - 1, day);
            
            return date.toLocaleDateString('es-CO', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        } catch (error) {
            console.error('Error formateando fecha:', error);
            return dateString;
        }
    };

    const hasActiveFilters = Object.values(filters).some(value => 
        value !== '' && value !== 'todos'
    );

    const handlePageChange = (page) => {
        setPagination(prev => ({ ...prev, current_page: page }));
    };

    // Función para abrir modal de aprobar/rechazar
    const openStatusModal = (document, action) => {
        setStatusModal({ 
            open: true, 
            document, 
            action,
            acta_number: '',
            observation: ''
        });
    };

    // Función para manejar el envío del formulario de aprobación/rechazo
    const handleStatusSubmit = () => {
        const { document, action, acta_number, acta_version, acta_fecha_apro, observation } = statusModal;

        if (action === 'aprobado') {
            if (!acta_number.trim()) {
                alert('Por favor ingresa el número de acta');
                return;
            }
            if (!acta_version.trim()) {
                alert('Por favor ingresa el número de versión');
                return;
            }
            if (!acta_fecha_apro) {
                alert('Por favor selecciona la fecha de vigencia');
                return;
            }
            updateDocumentStatus(document.id, action, acta_number, '', acta_version, acta_fecha_apro, '');
        } else if (action === 'rechazado') {
            if (!observation.trim()) {
                alert('Por favor ingresa una observación para el rechazo');
                return;
            }
            updateDocumentStatus(document.id, action, '', observation, '', '', '');
        }
    };

    // Función segura para renderizar usuarios
    const renderUserOptions = () => {
        if (!Array.isArray(users) || users.length === 0) {
            return <option value="">No hay usuarios disponibles</option>;
        }

        return (
            <>
                <option value="">Todos los usuarios</option>
                {users.map(user => (
                    <option key={user.id} value={user.id}>
                        {user.nombre} ({user.email}) - {user.cargo}
                    </option>
                ))}
            </>
        );
    };

    // Función para renderizar opciones de carpetas
    const renderFolderOptions = () => {
        if (!Array.isArray(folders) || folders.length === 0) {
            return <option value="">No hay carpetas disponibles</option>;
        }

        const renderFolderWithLevel = (folder, level = 0) => {
            const indent = '— '.repeat(level);
            return (
                <option key={folder.id} value={folder.id}>
                    {indent}📁 {folder.name}
                </option>
            );
        };

        const renderFoldersRecursive = (folderList, level = 0) => {
            return folderList.map(folder => (
                <React.Fragment key={folder.id}>
                    {renderFolderWithLevel(folder, level)}
                    {folder.children && renderFoldersRecursive(folder.children, level + 1)}
                </React.Fragment>
            ));
        };

        return (
            <>
                <option value="">Selecciona una carpeta</option>
                {renderFoldersRecursive(folders)}
            </>
        );
    };

    // Renderizar opciones de áreas
    const renderAreaOptions = () => {
        if (!Array.isArray(areasEmpresa) || areasEmpresa.length === 0) {
            return <option value="">No hay áreas disponibles</option>;
        }

        return (
            <>
                <option value="">Selecciona un área</option>
                {areasEmpresa.map(area => (
                    <option key={area.id} value={area.nombre}>
                        {area.nombre}
                    </option>
                ))}
            </>
        );
    };

    const renderTipoOptions = () => {
        if (!Array.isArray(tipoDocumento) || tipoDocumento.length === 0) {
            return <option value="">No hay Tipo de documento</option>;
        }

        return (
            <>
                <option value="">Selecciona Tipo Documento</option>
                {tipoDocumento.map(tipo => (
                    <option key={tipo.id} value={tipo.nombre}>
                        {tipo.nombre}
                    </option>
                ))}
            </>
        );
    };

    // Verificar si un usuario está bloqueado
    const isUserBlocked = (user) => {
        return user.bloqueado === 1;
    };

    // Verificar si el usuario es administrador
    const isAdmin = localStorage.getItem("idusuario") === "3" || localStorage.getItem("idusuario") === "1";

    // Verificar si se puede descargar el documento
    const canDownloadDocument = (document) => {
        return document.status === 'aprobado' || isAdmin;
    };

    // Verificar si se puede visualizar el documento
    const canViewDocument = (document) => {
        return isAdmin || document.status === 'aprobado';
    };

    // Verificar si el tipo de archivo es visualizable
    const isViewableFileType = (fileType) => {
        if (!fileType) return false;
        const viewableTypes = ['pdf', 'image', 'txt'];
        return viewableTypes.some(type => fileType.includes(type));
    };

    if (!isMounted.current) {
        return null;
    }

    return (
        <div className="content">
            <div className="container-fluid">
                <br />
                <div className="card">
                    <CardHeader className="bg-primary text-white">
                        <h3 className="mb-0">📋 Todos los Documentos*</h3>
                        <small>Gestión centralizada de todos los documentos del sistema</small>
                    </CardHeader>
                    <CardBody>
                        {/* Panel de Filtros Avanzados - MODIFICADO: Añadidos filtros de fecha de vigencia */}
                        <Card className="mb-4">
                            <CardBody>
                                <Row className="g-3">
                                    <Col md={3}>
                                        <FormGroup>
                                            <Label>Nombre del Documento</Label>
                                            <Input
                                                type="text"
                                                placeholder="Buscar por nombre..."
                                                value={filters.name}
                                                onChange={(e) => handleFilterChange('name', e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label>Estado</Label>
                                            <Input
                                                type="select"
                                                value={filters.status}
                                                onChange={(e) => handleFilterChange('status', e.target.value)}
                                            >
                                                <option value="todos">Todos</option>
                                                <option value="sin_revisar">Sin Revisar</option>
                                                <option value="en_proceso">En Proceso</option>
                                                <option value="aprobado">Aprobado</option>
                                                <option value="rechazado">Rechazado</option>
                                                <option value="reemplazado">Reemplazado</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label>Tipo de Solicitud</Label>
                                            <Input
                                                type="select"
                                                value={filters.request_type}
                                                onChange={(e) => handleFilterChange('request_type', e.target.value)}
                                            >
                                                <option value="todos">Todos</option>
                                                <option value="creacion">Creación</option>
                                                <option value="actualizacion">Actualización</option>
                                                <option value="eliminar">Eliminar</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label>Tipo de Documento</Label>
                                            <Input
                                                type="select"
                                                value={filters.tipo_documento}
                                                onChange={(e) => handleFilterChange('tipo_documento', e.target.value)}
                                            >
                                                <option value="todos">Todos</option>
                                                {renderTipoOptions()}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup>
                                            <Label>Área Solicitante</Label>
                                            <Input
                                                type="select"
                                                value={filters.area_solicitante}
                                                onChange={(e) => handleFilterChange('area_solicitante', e.target.value)}
                                            >
                                                <option value="">Todas las áreas</option>
                                                {renderAreaOptions()}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                
                                <Row className="g-3 mt-2">
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label>Fecha Inicio Solicitud</Label>
                                            <Input
                                                type="date"
                                                value={filters.start_date}
                                                onChange={(e) => handleFilterChange('start_date', e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label>Fecha Fin Solicitud</Label>
                                            <Input
                                                type="date"
                                                value={filters.end_date}
                                                onChange={(e) => handleFilterChange('end_date', e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    {/* NUEVOS FILTROS DE FECHA DE VIGENCIA */}
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label>Fecha Inicio Vigencia</Label>
                                            <Input
                                                type="date"
                                                value={filters.approval_start_date}
                                                onChange={(e) => handleFilterChange('approval_start_date', e.target.value)}
                                                title="Filtrar por fecha inicial de vigencia del documento"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label>Fecha Fin Vigencia</Label>
                                            <Input
                                                type="date"
                                                value={filters.approval_end_date}
                                                onChange={(e) => handleFilterChange('approval_end_date', e.target.value)}
                                                title="Filtrar por fecha final de vigencia del documento"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label>Usuario Solicitante</Label>
                                            <Input
                                                type="select"
                                                value={filters.user_id}
                                                onChange={(e) => handleFilterChange('user_id', e.target.value)}
                                                disabled={loadingUsers}
                                            >
                                                {loadingUsers ? (
                                                    <option>Cargando usuarios...</option>
                                                ) : (
                                                    renderUserOptions()
                                                )}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label>Carpeta</Label>
                                            <Input
                                                type="select"
                                                value={filters.folder_id}
                                                onChange={(e) => handleFilterChange('folder_id', e.target.value)}
                                                disabled={loadingFolders}
                                            >
                                                {loadingFolders ? (
                                                    <option>Cargando carpetas...</option>
                                                ) : (
                                                    <>
                                                        <option value="todos">Todas las carpetas</option>
                                                        {renderFolderOptions()}
                                                    </>
                                                )}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row className="g-3 mt-2">
                                    <Col md={12} className="d-flex align-items-end">
                                        <div className="d-flex gap-2 w-100">
                                            {hasActiveFilters && (
                                                <Button 
                                                    color="outline-secondary" 
                                                    onClick={clearFilters}
                                                    className="flex-grow-1"
                                                >
                                                    <i className="fas fa-times me-2"></i>
                                                    Limpiar Filtros
                                                </Button>
                                            )}
                                            <Button 
                                                color="primary" 
                                                onClick={loadDocuments}
                                                disabled={loading}
                                                className="flex-grow-1"
                                            >
                                                <i className="fas fa-search me-2"></i>
                                                {loading ? 'Buscando...' : 'Buscar'}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* Resumen y Botón Nuevo */}
                        <div className="row mb-4">
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="alert alert-info mb-0 flex-grow-1 me-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <strong>Total de documentos:</strong> {pagination.total} 
                                                {hasActiveFilters && ' (filtrados)'}
                                            </div>
                                            <div className="d-flex gap-3">
                                                {users.length > 0 && (
                                                    <div>
                                                        <strong>Usuarios:</strong> {users.length}
                                                    </div>
                                                )}
                                                {folders.length > 0 && (
                                                    <div>
                                                        <strong>Carpetas:</strong> {folders.length}
                                                    </div>
                                                )}
                                                {areasEmpresa.length > 0 && (
                                                    <div>
                                                        <strong>Áreas:</strong> {areasEmpresa.length}
                                                    </div>
                                                )}
                                                {isAdmin && (
                                                    <div>
                                                        <Badge color="success">Modo Administrador</Badge>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {isAdmin && (
                                        <Button 
                                            color="success" 
                                            onClick={openCreateModal}
                                            className="flex-shrink-0"
                                        >
                                            <i className="fas fa-plus me-2"></i>
                                            Nuevo Documento
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Tabla de Documentos */}
                        <Card>
                            <CardHeader className="bg-primary text-white d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">
                                    📄 Lista de Documentos ({documents.length} de {pagination.total})
                                    {hasActiveFilters && ' (filtrados)'}
                                </h5>
                                <div>
                                    <small className="me-3">
                                        Página {pagination.current_page} de {pagination.last_page}
                                    </small>
                                    {hasActiveFilters && (
                                        <Button color="light" size="sm" onClick={clearFilters}>
                                            <i className="fas fa-times me-1"></i>
                                            Limpiar
                                        </Button>
                                    )}
                                </div>
                            </CardHeader>
                            <CardBody>
                                {loading ? (
                                    <div className="text-center py-4">
                                        <Spinner color="primary" />
                                        <p className="mt-2">Cargando documentos...</p>
                                    </div>
                                ) : documents.length > 0 ? (
                                    <>
                                        <div className="table-responsive">
                                            <Table hover striped>
                                                <thead>
                                                    <tr>
                                                        <th width="50px">Código</th>
                                                        <th>Nombre del Documento</th>
                                                        <th>Tipo Doc.</th>
                                                        <th>Área</th>
                                                        <th>Ruta de Carpeta</th>
                                                        <th width="120px">Solicitante</th>
                                                        <th width="100px">Solicitud</th>
                                           
                                                        <th width="120px">Estado</th>
                                                        <th width="120px">Fecha Solicitud</th>
                                                        <th width="120px">Fecha Vigencia</th>
                                                        <th width="250px" className="text-center">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {documents.map(doc => (
                                                        <tr key={doc.id}>
                                                            <td>
                                                                <small className="text-muted">
                                                                    {doc.codigo || 'N/A'}
                                                                </small>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <strong className="d-block">{getFileIcon(doc.file_type)} {doc.name}</strong>
                                                                    {doc.acta_number && (
                                                                        <small className="text-success d-block">
                                                                            <strong>Acta: {doc.acta_number}</strong>
                                                                        </small>
                                                                    )}
                                                                    {doc.documento_id && (
                                                                        <small className="text-info d-block">
                                                                            <i className="fas fa-link me-1"></i>
                                                                            Actualiza: {documento_nombre || 'Documento relacionado'}
                                                                        </small>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <small className="text-muted">
                                                                    {doc.tipo_documento}
                                                                </small>
                                                            </td>
                                                            <td>
                                                                <small className="text-muted">
                                                                    {doc.area_solicitante}
                                                                </small>
                                                            </td>
                                                            <td>
                                                                <small className="text-muted">
                                                                    {getFolderPath(doc)}
                                                                </small>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <small className="d-block">
                                                                        {getUserName(doc.user)}
                                                                    </small>
                                                                    {doc.user && isUserBlocked(doc.user) && (
                                                                        <Badge color="danger" size="sm">
                                                                            Bloqueado
                                                                        </Badge>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <Badge color="info" className="text-capitalize">
                                                                    {doc.request_type}
                                                                </Badge>
                                                                <small className="text-muted">
                                                                    v{doc.version} 
                                                                </small>
                                                            </td>
                                                            
                                                            <td>
                                                                {getStatusBadge(doc.status)}
                                                            </td>
                                                            <td>
                                                                <small className="text-muted">
                                                                    {formatDate(doc.creation_date)}
                                                                </small>
                                                            </td>
                                                            <td>
                                                                <small className="text-muted">
                                                                    {formatDate(doc.approval_date)}
                                                                </small>
                                                            </td>
                                                            <td className="text-center">
                                                                <div className="btn-group btn-group-sm" role="group">
                                                                    {/* Botón para ver detalles */}
                                                                    <Button 
                                                                        color="outline-info"
                                                                        size="sm"
                                                                        onClick={() => viewDocumentDetails(doc)}
                                                                        title="Ver detalles"
                                                                    >
                                                                        📋
                                                                    </Button>
                                                                    
                                                                    {/* Botón para ver documento */}
                                                                    {canViewDocument(doc) && isViewableFileType(doc.file_type) && (
                                                                        <Button 
                                                                            color="outline-primary"
                                                                            size="sm"
                                                                            onClick={() => viewDocument(doc)}
                                                                            title="Ver documento"
                                                                        >
                                                                            👁️
                                                                        </Button>
                                                                    )}
                                                                    
                                                                    {/* Botón para descargar documento */}
                                                                    {canDownloadDocument(doc) && (
                                                                        <Button 
                                                                            color="outline-success"
                                                                            size="sm"
                                                                            onClick={() => downloadDocument(doc)}
                                                                            title="Descargar documento"
                                                                        >
                                                                            ⬇️
                                                                        </Button>
                                                                    )}

                                                                    {/* Botones de administrador */}
                                                                    {isAdmin && (doc.status === 'sin_revisar' || doc.status === 'en_proceso') && (
                                                                        <>
                                                                            <Button 
                                                                                color="outline-success"
                                                                                size="sm"
                                                                                onClick={() => openStatusModal(doc, 'aprobado')}
                                                                                title="Aprobar"
                                                                            >
                                                                                ✓
                                                                            </Button>
                                                                            <Button 
                                                                                color="outline-danger"
                                                                                size="sm"
                                                                                onClick={() => openStatusModal(doc, 'rechazado')}
                                                                                title="Rechazar"
                                                                            >
                                                                                ✗
                                                                            </Button>
                                                                        </>
                                                                    )}
                                                                    {isAdmin && (
                                                                        doc.status!='aprobado'?
                                                                        <Button 
                                                                            color="outline-warning"
                                                                            size="sm"
                                                                            onClick={() => openEditModal(doc)}
                                                                            title="Editar documento"
                                                                        >
                                                                            ✏️
                                                                        </Button>:''
                                                                    )}
                                                                    {/* Botón eliminar (solo admin) */}
                                                                    {isAdmin && (
                                                                        <Button 
                                                                            color="outline-danger"
                                                                            size="sm"
                                                                            onClick={() => deleteDocument(doc.id)}
                                                                            title="Eliminar"
                                                                            >
                                                                            🗑️
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>

                                        {/* Paginación */}
                                        {pagination.last_page > 1 && (
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <small>
                                                    Mostrando {documents.length} de {pagination.total} documentos
                                                </small>
                                                <div className="btn-group">
                                                    <Button
                                                        color="outline-primary"
                                                        size="sm"
                                                        disabled={pagination.current_page === 1}
                                                        onClick={() => handlePageChange(pagination.current_page - 1)}
                                                    >
                                                        ‹ Anterior
                                                    </Button>
                                                    {[...Array(pagination.last_page)].map((_, index) => (
                                                        <Button
                                                            key={index + 1}
                                                            color={pagination.current_page === index + 1 ? "primary" : "outline-primary"}
                                                            size="sm"
                                                            onClick={() => handlePageChange(index + 1)}
                                                        >
                                                            {index + 1}
                                                        </Button>
                                                    ))}
                                                    <Button
                                                        color="outline-primary"
                                                        size="sm"
                                                        disabled={pagination.current_page === pagination.last_page}
                                                        onClick={() => handlePageChange(pagination.current_page + 1)}
                                                    >
                                                        Siguiente ›
                                                    </Button>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div className="text-center py-4">
                                        <div className="fs-1 text-muted mb-3">📄</div>
                                        <h5 className="text-muted">
                                            {hasActiveFilters ? 'No hay documentos que coincidan con los filtros' : 'No hay documentos en el sistema'}
                                        </h5>
                                        <p className="text-muted">
                                            {hasActiveFilters 
                                                ? 'Intenta con otros criterios de búsqueda' 
                                                : 'Los documentos aparecerán aquí una vez sean creados'
                                            }
                                        </p>
                                        {hasActiveFilters && (
                                            <Button color="primary" onClick={clearFilters}>
                                                Limpiar Filtros
                                            </Button>
                                        )}
                                        {isAdmin && !hasActiveFilters && (
                                            <Button color="success" onClick={openCreateModal} className="ms-2">
                                                <i className="fas fa-plus me-2"></i>
                                                Crear Primer Documento
                                            </Button>
                                        )}
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </CardBody>
                </div>
            </div>

            {/* Modal para crear nuevo documento */}
            <Modal isOpen={createModal.open} toggle={() => setCreateModal({ 
                open: false, 
                formData: {
                    name: '',
                    description: '',
                    observacion_solicitud: '',
                    version: '',
                    tipo_documento: '',
                    area_solicitante: '',
                    request_type: '',
                    creation_date: '',
                    folder_id: '',
                    documento_id: null,
                    pregunta_1: false,
                    pregunta_2: false,
                    pregunta_3: false,
                    pregunta_4: false
                },
                file: null,
                uploading: false
            })} size="lg">
                <ModalHeader toggle={() => setCreateModal({ 
                    open: false, 
                    formData: {
                        name: '',
                        description: '',
                        observacion_solicitud: '',
                        version: '',
                        tipo_documento: '',
                        area_solicitante: '',
                        request_type: '',
                        creation_date: '',
                        folder_id: '',
                        documento_id: null,
                        pregunta_1: false,
                        pregunta_2: false,
                        pregunta_3: false,
                        pregunta_4: false
                    },
                    file: null,
                    uploading: false
                })}>
                    📄 Crear Nuevo Documento
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Nombre del Documento *</Label>
                                    <Input
                                        type="text"
                                        value={createModal.formData.name}
                                        onChange={(e) => handleCreateChange('name', e.target.value)}
                                        placeholder="Ingresa el nombre del documento"
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Tipo de Documento *</Label>
                                    <Input
                                        type="select"
                                        value={createModal.formData.tipo_documento}
                                        onChange={(e) => handleCreateChange('tipo_documento', e.target.value)}
                                        required
                                    >
                                        {renderTipoOptions()}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Área Solicitante *</Label>
                                    <Input
                                        type="select"
                                        value={createModal.formData.area_solicitante}
                                        onChange={(e) => handleCreateChange('area_solicitante', e.target.value)}
                                        required
                                    >
                                        {renderAreaOptions()}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Tipo de Solicitud *</Label>
                                    <Input
                                        type="select"
                                        value={createModal.formData.request_type}
                                        onChange={(e) => handleCreateChange('request_type', e.target.value)}
                                        required
                                    >
                                        <option value="">Selecciona un tipo</option>
                                        <option value="creacion">Creación</option>
                                        <option value="actualizacion">Actualización</option>
                                        <option value="eliminar">Eliminar</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        {/* Campo para documento a actualizar (solo para tipo actualizacion) */}
                        {createModal.formData.request_type === 'actualizacion' && (
                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label>Documento a Actualizar *</Label>
                                        {createModal.formData.documento_id ? (
                                            <div className="border rounded p-3 bg-light">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <strong>Documento seleccionado</strong>
                                                        <div>
                                                            <small className="text-muted">
                                                                {documento_nombre} 
                                                            </small>
                                                        </div>
                                                        <div>
                                                            <small className="text-muted">
                                                                Código: {documento_codigo} | 
                                                                Versión: {documento_version} | 
                                                                Solicitante: {documento_solicitante}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <Button 
                                                        color="outline-primary" 
                                                        size="sm"
                                                        onClick={() => {
                                                            loadDocumentosAprobados();
                                                            setSelectDocumentoModal({
                                                                open: true,
                                                                forCreate: true
                                                            });
                                                        }}
                                                    >
                                                        Cambiar
                                                    </Button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <Button 
                                                    color="outline-primary"
                                                    onClick={() => {
                                                        loadDocumentosAprobados();
                                                        setSelectDocumentoModal({
                                                            open: true,
                                                            forCreate: true
                                                        });
                                                    }}
                                                    block
                                                >
                                                    <i className="fas fa-search me-2"></i>
                                                    Seleccionar Documento a Actualizar
                                                </Button>
                                                <small className="text-danger d-block mt-1">
                                                    Debes seleccionar un documento aprobado que será actualizado
                                                </small>
                                            </div>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Versión *</Label>
                                    <Input
                                        type="text"
                                        value={createModal.formData.version}
                                        onChange={(e) => handleCreateChange('version', e.target.value)}
                                        placeholder="Ej: 1.0, 2.1, etc."
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Fecha de Solicitud *</Label>
                                    <Input
                                        type="date"
                                        readOnly
                                        value={createModal.formData.creation_date}
                                        onChange={(e) => handleCreateChange('creation_date', e.target.value)}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Carpeta *</Label>
                                    <Input
                                        type="select"
                                        value={createModal.formData.folder_id}
                                        onChange={(e) => handleCreateChange('folder_id', e.target.value)}
                                        required
                                        disabled={loadingFolders}
                                    >
                                        {loadingFolders ? (
                                            <option>Cargando carpetas...</option>
                                        ) : (
                                            renderFolderOptions()
                                        )}
                                    </Input>
                                    <small className="text-muted">
                                        Selecciona la carpeta donde se almacenará el documento
                                    </small>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Archivo *</Label>
                                    <Input
                                        type="file"
                                        onChange={handleCreateFileChange}
                                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt"
                                        required
                                    />
                                    <small className="text-muted">
                                        Formatos permitidos: PDF, Word, Excel, imágenes, texto (Max. 10MB)
                                    </small>
                                    {createModal.file && (
                                        <Alert color="info" className="mt-2">
                                            <strong>Archivo seleccionado:</strong> {createModal.file.name}
                                        </Alert>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <Label>Descripción del documento*</Label>
                            <Input
                                type="textarea"
                                rows="3"
                                value={createModal.formData.description}
                                onChange={(e) => handleCreateChange('description', e.target.value)}
                                placeholder="Describe el  contenido del documento"
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Descripción de la solicitud *</Label>
                            <Input
                                type="textarea"
                                rows="3"
                                value={createModal.formData.observacion_solicitud}
                                onChange={(e) => handleCreateChange('observacion_solicitud', e.target.value)}
                                placeholder="Describe el propósito de la solicitud"
                                required
                            />
                        </FormGroup>

                        {/* Preguntas de repercusión */}
                        <Card className="mb-3">
                            <CardHeader className="bg-light text-dark">
                                <h6 className="mb-0">📋 Repercusión del Cambio en Otros Documentos</h6>
                            </CardHeader>
                            <CardBody>
                                <FormGroup check className="mb-3">
                                    <Input
                                        type="checkbox"
                                        checked={createModal.formData.pregunta_1}
                                        onChange={(e) => handleCreateChange('pregunta_1', e.target.checked)}
                                    />
                                    <Label check>
                                        Se crea o da de baja un documento del sistema de calidad
                                    </Label>
                                </FormGroup>

                                <FormGroup check className="mb-3">
                                    <Input
                                        type="checkbox"
                                        checked={createModal.formData.pregunta_2}
                                        onChange={(e) => handleCreateChange('pregunta_2', e.target.checked)}
                                    />
                                    <Label check>
                                        Se crea, da de baja o se cambia el título a un formato del sistema de calidad
                                    </Label>
                                </FormGroup>

                                <FormGroup check className="mb-3">
                                    <Input
                                        type="checkbox"
                                        checked={createModal.formData.pregunta_3}
                                        onChange={(e) => handleCreateChange('pregunta_3', e.target.checked)}
                                    />
                                    <Label check>
                                        Se cambian, incluyen o excluyen los títulos de los cargos en el organigrama y demás documentos del sistema de calidad
                                    </Label>
                                </FormGroup>

                                <FormGroup check className="mb-3">
                                    <Input
                                        type="checkbox"
                                        checked={createModal.formData.pregunta_4}
                                        onChange={(e) => handleCreateChange('pregunta_4', e.target.checked)}
                                    />
                                    <Label check>
                                        La creación, actualización o dada de baja afecta la documentación del sistema de calidad
                                    </Label>
                                </FormGroup>
                            </CardBody>
                        </Card>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <Button 
                                color="secondary" 
                                onClick={() => setCreateModal({ 
                                    open: false, 
                                    formData: {
                                        name: '',
                                        description: '',
                                        observacion_solicitud: '',
                                        version: '',
                                        tipo_documento: '',
                                        area_solicitante: '',
                                        request_type: '',
                                        creation_date: '',
                                        folder_id: '',
                                        documento_id: null,
                                        pregunta_1: false,
                                        pregunta_2: false,
                                        pregunta_3: false,
                                        pregunta_4: false
                                    },
                                    file: null,
                                    uploading: false
                                })}
                                disabled={createModal.uploading}
                            >
                                Cancelar
                            </Button>
                            <Button 
                                color="primary" 
                                onClick={createDocument}
                                disabled={createModal.uploading || !createModal.file || !createModal.formData.folder_id ||
                                    (createModal.formData.request_type === 'actualizacion' && !createModal.formData.documento_id)}
                            >
                                {createModal.uploading ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Creando...
                                    </>
                                ) : (
                                    <>
                                        <i className="fas fa-save me-2"></i>
                                        Crear Documento
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            {/* Modal para editar documento */}
            <Modal isOpen={editModal.open} toggle={() => setEditModal({ 
                open: false, 
                document: null,
                formData: {
                    name: '',
                    description: '',
                    observacion_solicitud: '',
                    version: '',
                    tipo_documento: '',
                    area_solicitante: '',
                    request_type: '',
                    creation_date: '',
                    folder_id: '',
                    documento_id: null,
                    pregunta_1: false,
                    pregunta_2: false,
                    pregunta_3: false,
                    pregunta_4: false
                },
                file: null,
                uploading: false,
                replaceFile: false
            })} size="lg">
                <ModalHeader toggle={() => setEditModal({ 
                    open: false, 
                    document: null,
                    formData: {
                        name: '',
                        description: '',
                        observacion_solicitud: '',
                        version: '',
                        tipo_documento: '',
                        area_solicitante: '',
                        request_type: '',
                        creation_date: '',
                        folder_id: '',
                        documento_id: null,
                        pregunta_1: false,
                        pregunta_2: false,
                        pregunta_3: false,
                        pregunta_4: false
                    },
                    file: null,
                    uploading: false,
                    replaceFile: false
                })}>
                    ✏️ Editar Documento
                </ModalHeader>
                <ModalBody>
                    {editModal.document && (
                        <Form>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Nombre del Documento *</Label>
                                        <Input
                                            type="text"
                                            value={editModal.formData.name}
                                            onChange={(e) => handleEditChange('name', e.target.value)}
                                            placeholder="Ingresa el nombre del documento"
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Tipo de Documento *</Label>
                                        <Input
                                            type="select"
                                            value={editModal.formData.tipo_documento}
                                            onChange={(e) => handleEditChange('tipo_documento', e.target.value)}
                                            required
                                        >
                                            {renderTipoOptions()}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                 <Col md={6}>
                                    <FormGroup>
                                        <Label>Estado *</Label>
                                        <Input
                                            type="select"
                                            value={editModal.formData.status}
                                            onChange={(e) => handleEditChange('status', e.target.value)}
                                            required
                                        >
                                            <option value="sin_revisar">Sin Revisar</option>
                                            <option value="en_proceso">En Proceso</option>
                                            <option value="aprobado" disabled>Aprobado</option>
                                            <option value="rechazado" disabled>Rechazado</option>
                                            <option value="reemplazado" disabled>Reemplazado</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Usuario Solicitante: </Label>
                                        <div className="p-2 border rounded">
                                            {editModal.formData.user}
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Área Solicitante *</Label>
                                        <Input
                                            type="select"
                                            value={editModal.formData.area_solicitante}
                                            onChange={(e) => handleEditChange('area_solicitante', e.target.value)}
                                            required
                                        >
                                            {renderAreaOptions()}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Tipo de Solicitud *</Label>
                                        <Input
                                            type="select"
                                            value={editModal.formData.request_type}
                                            onChange={(e) => handleEditChange('request_type', e.target.value)}
                                            required
                                        >
                                            <option value="">Selecciona un tipo</option>
                                            <option value="creacion">Creación</option>
                                            <option value="actualizacion">Actualización</option>
                                            <option value="eliminar">Eliminar</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>

                            {/* Campo para documento a actualizar (solo para tipo actualizacion) */}
                            {editModal.formData.request_type === 'actualizacion' && (
                                <Row>
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label>Documento a Actualizar *</Label>
                                            {editModal.formData.documento_id ? (
                                                <div className="border rounded p-3 bg-light">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <strong className="text-muted">{documento_nombre || 'Documento seleccionado'}</strong>
                                                            <div>
                                                                <small className="text-muted">
                                                                    Código: {documento_codigo || 'N/A'} | 
                                                                    Versión: {documento_version || 'N/A'} | 
                                                                    Solicitante: {documento_solicitante || 'N/A'}
                                                                </small>
                                                            </div>
                                                        </div>
                                                        <Button 
                                                            color="outline-primary" 
                                                            size="sm"
                                                            onClick={() => {
                                                                loadDocumentosAprobados();
                                                                setSelectDocumentoModal({
                                                                    open: true,
                                                                    forCreate: false
                                                                });
                                                            }}
                                                        >
                                                            Cambiar
                                                        </Button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>
                                                    <Button 
                                                        color="outline-primary"
                                                        onClick={() => {
                                                            loadDocumentosAprobados();
                                                            setSelectDocumentoModal({
                                                                open: true,
                                                                forCreate: false
                                                            });
                                                        }}
                                                        block
                                                    >
                                                        <i className="fas fa-search me-2"></i>
                                                        Seleccionar Documento a Actualizar
                                                    </Button>
                                                    <small className="text-danger d-block mt-1">
                                                        Debes seleccionar un documento aprobado que será actualizado
                                                    </small>
                                                </div>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            )}

                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Versión *</Label>
                                        <Input
                                            type="text"
                                            value={editModal.formData.version}
                                            onChange={(e) => handleEditChange('version', e.target.value)}
                                            placeholder="Ej: 1.0, 2.1, etc."
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Fecha de Solicitud *</Label>
                                        <Input
                                            type="date"
                                            value={editModal.formData.creation_date}
                                            onChange={(e) => handleEditChange('creation_date', e.target.value)}
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Carpeta *</Label>
                                        <Input
                                            type="select"
                                            value={editModal.formData.folder_id}
                                            onChange={(e) => handleEditChange('folder_id', e.target.value)}
                                            required
                                            disabled={loadingFolders}
                                        >
                                            {loadingFolders ? (
                                                <option>Cargando carpetas...</option>
                                            ) : (
                                                renderFolderOptions()
                                            )}
                                        </Input>
                                        <small className="text-muted">
                                            Selecciona la carpeta donde se almacenará el documento
                                        </small>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Reemplazar Archivo</Label>
                                        <Input
                                            type="file"
                                            onChange={handleEditFileChange}
                                            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt"
                                        />
                                        <small className="text-muted">
                                            Deja vacío para mantener el archivo actual: {editModal.document.file_path}
                                        </small>
                                        {editModal.file && (
                                            <Alert color="info" className="mt-2">
                                                <strong>Nuevo archivo seleccionado:</strong> {editModal.file.name}
                                            </Alert>
                                        )}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <FormGroup>
                                <Label>Descripción *</Label>
                                <Input
                                    type="textarea"
                                    rows="3"
                                    value={editModal.formData.description}
                                    onChange={(e) => handleEditChange('description', e.target.value)}
                                    placeholder="Describe el propósito y contenido del documento"
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Observacion Solicitud *</Label>
                                <Input
                                    type="textarea"
                                    rows="3"
                                    value={editModal.formData.observacion_solicitud}
                                    onChange={(e) => handleEditChange('observacion_solicitud', e.target.value)}
                                    placeholder="Describe la observacion de la solicitud"
                                    required
                                />
                            </FormGroup>

                            {/* Preguntas de repercusión */}
                            <Card className="mb-3">
                                <CardHeader className="bg-light text-dark">
                                    <h6 className="mb-0">📋 Repercusión del Cambio en Otros Documentos</h6>
                                </CardHeader>
                                <CardBody>
                                    <FormGroup check className="mb-3">
                                        <Input
                                            type="checkbox"
                                            checked={editModal.formData.pregunta_1}
                                            onChange={(e) => handleEditChange('pregunta_1', e.target.checked)}
                                        />
                                        <Label check>
                                            Se crea o da de baja un documento del sistema de calidad
                                        </Label>
                                    </FormGroup>

                                    <FormGroup check className="mb-3">
                                        <Input
                                            type="checkbox"
                                            checked={editModal.formData.pregunta_2}
                                            onChange={(e) => handleEditChange('pregunta_2', e.target.checked)}
                                        />
                                        <Label check>
                                            Se crea, da de baja o se cambia el título a un formato del sistema de calidad
                                        </Label>
                                    </FormGroup>

                                    <FormGroup check className="mb-3">
                                        <Input
                                            type="checkbox"
                                            checked={editModal.formData.pregunta_3}
                                            onChange={(e) => handleEditChange('pregunta_3', e.target.checked)}
                                        />
                                        <Label check>
                                            Se cambian, incluyen o excluyen los títulos de los cargos en el organigrama y demás documentos del sistema de calidad
                                        </Label>
                                    </FormGroup>

                                    <FormGroup check className="mb-3">
                                        <Input
                                            type="checkbox"
                                            checked={editModal.formData.pregunta_4}
                                            onChange={(e) => handleEditChange('pregunta_4', e.target.checked)}
                                        />
                                        <Label check>
                                            La creación, actualización o dada de baja afecta la documentación del sistema de calidad
                                        </Label>
                                    </FormGroup>
                                </CardBody>
                            </Card>

                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <Button 
                                    color="secondary" 
                                    onClick={() => setEditModal({ 
                                        open: false, 
                                        document: null,
                                        formData: {
                                            name: '',
                                            description: '',
                                            observacion_solicitud: '',
                                            version: '',
                                            tipo_documento: '',
                                            area_solicitante: '',
                                            request_type: '',
                                            creation_date: '',
                                            folder_id: '',
                                            documento_id: null,
                                            pregunta_1: false,
                                            pregunta_2: false,
                                            pregunta_3: false,
                                            pregunta_4: false
                                        },
                                        file: null,
                                        uploading: false,
                                        replaceFile: false
                                    })}
                                    disabled={editModal.uploading}
                                >
                                    Cancelar
                                </Button>
                                <Button 
                                    color="primary" 
                                    onClick={updateDocument}
                                    disabled={editModal.uploading || 
                                        (editModal.formData.request_type === 'actualizacion' && !editModal.formData.documento_id)}
                                >
                                    {editModal.uploading ? (
                                        <>
                                            <Spinner size="sm" className="me-2" />
                                            Actualizando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-save me-2"></i>
                                            Guardar Cambios
                                        </>
                                    )}
                                </Button>
                            </div>
                        </Form>
                    )}
                </ModalBody>
            </Modal>

            {/* Modal para seleccionar documento a actualizar */}
            <Modal isOpen={selectDocumentoModal.open} toggle={() => setSelectDocumentoModal({ open: false, forCreate: false })} size="lg">
                <ModalHeader toggle={() => setSelectDocumentoModal({ open: false, forCreate: false })}>
                    📋 Seleccionar Documento a Actualizar
                </ModalHeader>
                <ModalBody>
                    <Alert color="info">
                        <strong>Importante:</strong> Solo puedes seleccionar documentos que estén en estado "Aprobado"
                    </Alert>

                    {/* Filtros para documentos aprobados */}
                    <Card className="mb-3">
                        <CardBody>
                            <h6 className="mb-3">🔍 Filtros de Búsqueda</h6>
                            <Row className="g-3">
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>Nombre del Documento</Label>
                                        <Input
                                            type="text"
                                            placeholder="Buscar por nombre..."
                                            value={filtrosDocumentosAprobados.name}
                                            onChange={(e) => handleFiltrosDocumentosAprobadosChange('name', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label>Código</Label>
                                        <Input
                                            type="text"
                                            placeholder="Buscar por código..."
                                            value={filtrosDocumentosAprobados.codigo}
                                            onChange={(e) => handleFiltrosDocumentosAprobadosChange('codigo', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label>Área Solicitante</Label>
                                        <Input
                                            type="text"
                                            placeholder="Buscar por área..."
                                            value={filtrosDocumentosAprobados.area_solicitante}
                                            onChange={(e) => handleFiltrosDocumentosAprobadosChange('area_solicitante', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label>Tipo Documento</Label>
                                        <Input
                                            type="text"
                                            placeholder="Buscar por tipo..."
                                            value={filtrosDocumentosAprobados.tipo_documento}
                                            onChange={(e) => handleFiltrosDocumentosAprobadosChange('tipo_documento', e.target.value)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-between mt-3">
                                <Button 
                                    color="outline-secondary" 
                                    size="sm"
                                    onClick={clearFiltrosDocumentosAprobados}
                                >
                                    <i className="fas fa-times me-1"></i>
                                    Limpiar Filtros
                                </Button>
                                <Button 
                                    color="primary" 
                                    size="sm"
                                    onClick={loadDocumentosAprobados}
                                    disabled={loadingDocumentosAprobados}
                                >
                                    {loadingDocumentosAprobados ? (
                                        <>
                                            <Spinner size="sm" className="me-1" />
                                            Buscando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-search me-1"></i>
                                            Buscar
                                        </>
                                    )}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>

                    {loadingDocumentosAprobados ? (
                        <div className="text-center py-4">
                            <Spinner color="primary" />
                            <p className="mt-2">Cargando documentos aprobados...</p>
                        </div>
                    ) : documentosAprobados.length > 0 ? (
                        <div className="table-responsive">
                            <Table hover striped responsive>
                                <thead>
                                    <tr>
                                        <th>Seleccionar</th>
                                        <th>Nombre</th>
                                        <th>Código</th>
                                        <th>Versión</th>
                                        <th>Área</th>
                                        <th>Tipo</th>
                                        <th>Fecha Aprobación</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documentosAprobados.map(doc => (
                                        <tr key={doc.id}>
                                            <td>
                                                <Button 
                                                    color="primary" 
                                                    size="sm"
                                                    onClick={() => selectDocumento(doc)}
                                                >
                                                    Seleccionar
                                                </Button>
                                            </td>
                                            <td>{doc.name}</td>
                                            <td>{doc.codigo || 'N/A'}</td>
                                            <td>v{doc.version}</td>
                                            <td>{doc.area_solicitante}</td>
                                            <td>{doc.tipo_documento || 'N/A'}</td>
                                            <td>
                                                {doc.approval_date ? formatDate(doc.approval_date) : 'N/A'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <div className="fs-1 text-muted mb-3">📄</div>
                            <h5>No hay documentos aprobados disponibles</h5>
                            <p>No se encontraron documentos en estado "Aprobado" para seleccionar.</p>
                            <Button 
                                color="primary" 
                                onClick={loadDocumentosAprobados}
                                className="mt-2"
                            >
                                <i className="fas fa-redo me-2"></i>
                                Reintentar
                            </Button>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            {/* Modal para ver detalles del documento */}
            <Modal isOpen={detailModal.open} toggle={() => setDetailModal({ open: false, document: null })} size="lg">
                <ModalHeader toggle={() => setDetailModal({ open: false, document: null })}>
                    📋 Detalles del Documento
                </ModalHeader>
                <ModalBody>
                    {detailModal.document && (
                        <div>
                            {/* Información básica */}
                            <Card className="mb-4">
                                <CardHeader className="bg-light text-dark">
                                    <h6 className="mb-0">📄 Información Básica</h6>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Código:</strong>
                                            <p>{detailModal.document.codigo || 'N/A'}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Nombre del Documento:</strong>
                                            <p>{detailModal.document.name}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Tipo de Documento:</strong>
                                            <p>{detailModal.document.tipo_documento}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Área Solicitante:</strong>
                                            <p>{detailModal.document.area_solicitante}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Tipo de Solicitud:</strong>
                                            <p>
                                                <Badge color="info" className="text-capitalize">
                                                    {detailModal.document.request_type}
                                                </Badge>
                                            </p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Versión:</strong>
                                            <p>v{detailModal.document.version}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Fecha de Solicitud:</strong>
                                            <p>{formatDate(detailModal.document.creation_date)}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Estado:</strong>
                                            <p>{getStatusBadge(detailModal.document.status)}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <strong>Descripción del documento:</strong>
                                            <p>{detailModal.document.description}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <strong>Descripción Solicitud:</strong>
                                            <p>{detailModal.document.observacion_solicitud}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Tamaño del Archivo:</strong>
                                            <p>{formatFileSize(detailModal.document.file_size)}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Ruta de Carpeta:</strong>
                                            <p className="text-muted">{getFolderPath(detailModal.document)}</p>
                                        </Col>
                                    </Row>
                                    {detailModal.document.documento_id && (
                                        <Row>
                                            <Col md={12}>
                                                <strong>Documento que actualiza:</strong>
                                                <div className="border rounded p-2 bg-light">
                                                    <div>
                                                        <small className="text-muted">
                                                            <strong>{documento_nombre || 'Documento relacionado'}</strong>
                                                        </small>
                                                    </div>
                                                    <div>
                                                        <small className="text-muted">
                                                            Código: {documento_codigo || 'N/A'} | 
                                                            Versión: {documento_version || 'N/A'} | 
                                                            Solicitante: {documento_solicitante || 'N/A'}
                                                        </small>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    {detailModal.document.acta_number && (
                                        <Row>
                                            <Col md={12}>
                                                <strong>Número de Acta:</strong>
                                                <p className="text-success fw-bold">{detailModal.document.acta_number}</p>
                                            </Col>
                                        </Row>
                                    )}
                                    {detailModal.document.rejection_observation && (
                                        <Row>
                                            <Col md={12}>
                                                <strong>Observación de Rechazo:</strong>
                                                <p className="text-danger">{detailModal.document.rejection_observation}</p>
                                            </Col>
                                        </Row>
                                    )}
                                </CardBody>
                            </Card>

                            {/* Repercusión en otros documentos */}
                            <Card className="mb-4">
                                <CardHeader className="bg-light text-dark">
                                    <h6 className="mb-0">📋 Repercusión del Cambio en Otros Documentos</h6>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                            <div className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                                <span>{getPreguntaText(1)}</span>
                                                {getPreguntaBadge(detailModal.document.pregunta_1)}
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                                <span>{getPreguntaText(2)}</span>
                                                {getPreguntaBadge(detailModal.document.pregunta_2)}
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                                <span>{getPreguntaText(3)}</span>
                                                {getPreguntaBadge(detailModal.document.pregunta_3)}
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                                <span>{getPreguntaText(4)}</span>
                                                {getPreguntaBadge(detailModal.document.pregunta_4)}
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Información del usuario */}
                            <Card className="mb-4">
                                <CardHeader className="bg-light text-dark">
                                    <h6 className="mb-0">👤 Información del Usuario</h6>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={6}>
                                            <strong>Creado por:</strong>
                                            <p>{getUserName(detailModal.document.user)}</p>
                                        </Col>
                                        <Col md={6}>
                                            <strong>Fecha de Solicitud:</strong>
                                            <p>{formatDate(detailModal.document.creation_date)}</p>
                                        </Col>
                                    </Row>
                                    {detailModal.document.approver && (
                                        <Row>
                                            <Col md={6}>
                                                <strong>Aprobado por:</strong>
                                                <p>{getUserName(detailModal.document.approver)}</p>
                                            </Col>
                                            <Col md={6}>
                                                <strong>Fecha de Vigencia:</strong>
                                                <p>{formatDate(detailModal.document.approval_date)}</p>
                                            </Col>
                                        </Row>
                                    )}
                                </CardBody>
                            </Card>

                            {/* Botones de acción */}
                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <Button 
                                    color="primary" 
                                    onClick={() => downloadDocument(detailModal.document)}
                                    disabled={!canDownloadDocument(detailModal.document)}
                                >
                                    <i className="fas fa-download me-2"></i>
                                    Descargar
                                </Button>
                                <Button 
                                    color="secondary" 
                                    onClick={() => setDetailModal({ open: false, document: null })}
                                >
                                    Cerrar
                                </Button>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            {/* Modal para aprobar/rechazar */}
            <Modal isOpen={statusModal.open} toggle={() => setStatusModal({ 
                open: false, 
                document: null, 
                action: '',
                acta_number: '',
                observation: ''
            })}>
                <ModalHeader toggle={() => setStatusModal({ 
                    open: false, 
                    document: null, 
                    action: '',
                    acta_number: '',
                    observation: ''
                })}>
                    {statusModal.action === 'aprobado' ? '✅ Aprobar Documento' : '❌ Rechazar Documento'}
                </ModalHeader>
                <ModalBody>
                    {statusModal.document && (
                        <div>
                            <div className="alert alert-info">
                                <strong>Documento:</strong> {statusModal.document.name}
                                <br />
                                <strong>Solicitante:</strong> {getUserName(statusModal.document.user)}
                                <br />
                                <strong>Tipo:</strong> {statusModal.document.tipo_documento} - {statusModal.document.request_type}
                            </div>

                            {statusModal.action === 'aprobado' ? (
                                <>
                                    <FormGroup>
                                        <Label for="acta_number">
                                            <strong>Número de Acta *</strong>
                                        </Label>
                                        <Input
                                            type="text"
                                            id="acta_number"
                                            placeholder="Ingresa el número de acta de aprobación..."
                                            value={statusModal.acta_number}
                                            onChange={(e) => setStatusModal(prev => ({ 
                                                ...prev, 
                                                acta_number: e.target.value 
                                            }))}
                                            required
                                        />
                                        <small className="text-muted">
                                            Este número identificará oficialmente la aprobación del documento.
                                        </small>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="acta_version">
                                            <strong>Versión Documento *</strong>
                                        </Label>
                                        <Input
                                            type="number"
                                            id="acta_version"
                                            placeholder="Ingresa el número de versión"
                                            value={statusModal.acta_version}
                                            onChange={(e) => setStatusModal(prev => ({ 
                                                ...prev, 
                                                acta_version: e.target.value 
                                            }))}
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="acta_fecha_apro">
                                            <strong>Fecha de Vigencia *</strong>
                                        </Label>
                                        <Input
                                            type="date"
                                            id="acta_fecha_apro"
                                            value={statusModal.acta_fecha_apro}
                                            onChange={(e) => setStatusModal(prev => ({ 
                                                ...prev, 
                                                acta_fecha_apro: e.target.value 
                                            }))}
                                            required
                                        />
                                    </FormGroup>
                                </>
                            ) : (
                                <FormGroup>
                                    <Label for="observation">
                                        <strong>Observación de Rechazo *</strong>
                                    </Label>
                                    <Input
                                        type="textarea"
                                        id="observation"
                                        placeholder="Ingresa la razón del rechazo..."
                                        value={statusModal.observation}
                                        onChange={(e) => setStatusModal(prev => ({ 
                                            ...prev, 
                                            observation: e.target.value 
                                        }))}
                                        rows="3"
                                        required
                                    />
                                    <small className="text-muted">
                                        Esta observación será visible para el usuario solicitante.
                                    </small>
                                </FormGroup>
                            )}

                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <Button 
                                    color="secondary" 
                                    onClick={() => setStatusModal({ 
                                        open: false, 
                                        document: null, 
                                        action: '',
                                        acta_number: '',
                                        observation: ''
                                    })}
                                >
                                    Cancelar
                                </Button>
                                <Button 
                                    color={statusModal.action === 'aprobado' ? 'success' : 'danger'}
                                    onClick={handleStatusSubmit}
                                    disabled={
                                        statusModal.action === 'aprobado' 
                                            ? !statusModal.acta_number || !statusModal.acta_version || !statusModal.acta_fecha_apro
                                            : !statusModal.observation
                                    }
                                >
                                    {statusModal.action === 'aprobado' ? '✅ Aprobar' : '❌ Rechazar'}
                                </Button>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            {/* Modal para visualizar documento */}
            <Modal isOpen={viewerModal.open} toggle={() => setViewerModal({ open: false, document: null })} size="xl">
                <ModalHeader toggle={() => setViewerModal({ open: false, document: null })}>
                    <div>
                        <div>Visualizar Documento: {viewerModal.document?.name} </div>
                        <small className="text-muted">
                            Ruta: {viewerModal.document && getFolderPath(viewerModal.document)}
                        </small>
                    </div>
                    <Button 
                        color="primary" 
                        size="sm" 
                        className="ms-2"
                        onClick={() => downloadDocument(viewerModal.document)}
                    >
                        <i className="fas fa-download me-1"></i>
                        Descargar
                    </Button>
                </ModalHeader>
                <ModalBody style={{ height: '80vh', padding: '0' }}>
                    {viewerModal.document && (
                        <div style={{ height: '100%', width: '100%' }}>
                            {viewerModal.document.file_type?.includes('pdf') ? (
                                <iframe 
                                    src={viewerModal.document.file_url}
                                    style={{ width: '100%', height: '100%', border: 'none' }}
                                    title={viewerModal.document.name}
                                />
                            ) : viewerModal.document.file_type?.includes('image') ? (
                                <div className="text-center p-3">
                                    <img 
                                        src={viewerModal.document.file_url}
                                        alt={viewerModal.document.name}
                                        style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                                    />
                                </div>
                            ) : viewerModal.document.file_type?.includes('text') || viewerModal.document.file_type?.includes('txt') ? (
                                <iframe 
                                    src={viewerModal.document.file_url}
                                    style={{ width: '100%', height: '100%', border: 'none' }}
                                    title={viewerModal.document.name}
                                />
                            ) : (
                                <div className="text-center py-4">
                                    <div className="fs-1 text-muted mb-3">📄</div>
                                    <h5>Vista previa no disponible</h5>
                                    <p>Este tipo de archivo no se puede visualizar en el navegador.</p>
                                    <Button 
                                        color="primary"
                                        onClick={() => downloadDocument(viewerModal.document)}
                                    >
                                        <i className="fas fa-download me-2"></i>
                                        Descargar Documento
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}
                </ModalBody>
            </Modal>
        </div>
    );
};

export default AllDocuments;